export const common = {

  // Navbar

  "nav.home": "首页",

  "nav.about": "关于我们",

  "nav.services": "服务",

  "nav.portfolio": "投资组合",

  "nav.contact": "联系我们",

  "nav.startInvesting": "开始投资",

  // Hero

  "hero.badge": "成立于2019年",

  "hero.title1": "共筑",

  "hero.title2": "明日",

  "hero.title3": "传世基业",

  "hero.subtitle": "卓越投资",

  "hero.description": "ALEBEL是一家总部位于阿联酋的国际控股投资集团,专注于战略投资，企业并购及产业整合，在能源，科技，先进制造等领域持续创造长期价值。",

  "hero.discoverMore": "了解更多",

  "hero.getInTouch": "联系我们",

  "hero.portfolioCompanies": "投资组合公司",

  "hero.headquarters": "总部",

  "hero.established": "成立时间",

  "hero.strategicGrowth": "战略增长",

  "hero.valueCreation": "长期价值创造",

  "hero.scroll": "向下滚动",

  // About

  "about.label": "关于我们",

  "about.title1": "卓越",

  "about.title2": "战略投资",

"about.description": "ALEBEL投资是一家私人控股投资公司，专注于通过战略投资、积极管理和卓越运营，在多个行业创造长期价值。公司专注于投资能源、科技、电子、基础设施及工业解决方案等领域，支持具有创新能力和可持续增长潜力的企业。",

  "about.parentEntity": "控股母公司",

  "about.parentEntityDesc": "作为控股母公司，为旗下子公司及合作企业提供资本支持、公司治理和战略指导。。",

  "about.uaeBased": "总部位于阿联酋",

  "about.uaeBasedDesc": "公司总部设于阿拉伯联合酋长国，专注于区域及国际市场的战略投资与业务拓展。",

  "about.activeOwnership": "积极管理",

  "about.activeOwnershipDesc": "通过资本支持、战略规划及业务发展，持续提升投资组合企业的长期价值。",

  "about.innovationFocus": "聚焦创新",

  "about.innovationFocusDesc": "专注于能源、科技及工业解决方案等领域，投资具有创新能力和可持续发展潜力的企业。",

  "about.investmentSectors": "投资领域",

  "about.learnMore": "了解更多",

  "about.ceoQuote1": "在ALEBEL投资，我们致力于打造一家多元化、面向未来的国际投资集团，为股东、合作伙伴及社会持续创造长期价值。",

"about.ceoQuote2": "我们专注于发现可扩展的机遇,赋能管理团队,并支持能够适应不断变化的全球经济的创新驱动型企业。",

  "about.ceoName": "Mohamed Hamad Al Ameri",

  "about.ceoTitle": "CEO",

  // Sectors

  "sector.energy": "能源",

  "sector.technology": "科技",

  "sector.manufacturing": "制造业",

  "sector.electronics": "电子",

  "sector.industrial": "工业解决方案",

  // Services

  "services.label": "我们的服务",

  "services.title1": "我们的",

  "services.title2": "运营模式",

  "services.description": "我们通过全面的支持和战略性投资，为企业创造长期价值",

  "services.evaluation": "投资评估",

  "services.evaluationDesc": "我们持续发掘具备可持续增长潜力、商业模式成熟且管理团队优秀的投资机会。",

  "services.dueDiligence": "尽职调查",

  "services.dueDiligenceDesc": "我们开展全面的财务、商业、技术及法律尽职调查，确保每项投资符合我们的投资标准。",

  "services.activeManagement": "积极管理",

  "services.activeManagementDesc": "我们积极参与企业治理，为管理团队提供战略指导和运营支持。",

  "services.valueCreation": "价值创造",

  "services.valueCreationDesc": "我们提供指导、运营支持,并开放我们的网络资源以推动增长。",

  "services.forCompanies": "面向企业",

  "services.corporateServices": "企业服务",

  "services.corporateDesc": "我们支持旗下子公司独立运营，同时依托集团的资金实力、资源共享及完善的公司治理体系，实现持续发展。",

  "services.corporate1": "资金支持与资本投入",

  "services.corporate2": "战略规划与公司治理",

  "services.corporate3": "业务发展支持",

  "services.corporate4": "共享集团资源与全球合作网络",

  "services.forIndividuals": "个人服务",

  "services.entrepreneurSupport": "创业支持",

  "services.entrepreneurDesc": "通过全方位支持，帮助创业者和创新者将创意转化为可持续发展的企业。",

  "services.entrepreneur1": "支持创业者将创新理念转化为企业",

  "services.entrepreneur2": "投资早期及成长期初创企业",

  "services.entrepreneur3": "提供法律架构与种子资金",

  "services.entrepreneur4": "提供指导与战略建议",

  "services.entrepreneur5": "提供技术与产品开发指导",

  "services.learnMore": "了解更多",

  // Projects

  "projects.label": "投资组合",

  "projects.title1": "旗舰",

  "projects.title2": "项目",

  "projects.description": "通过在能源、科技及基础设施等领域的战略投资，推动创新、可持续发展与长期增长。",

  "projects.energy.title": "ALEBEL能源解决方案",

  "projects.energy.desc": "专注于电动工具、电动出行及工业应用领域的电池组、电池管理系统（BMS）及储能解决方案的开发与投资。",

  "projects.electronics.title": "ALEBEL电子",

  "projects.electronics.desc": "专注于电子产品研发、嵌入式系统、物联网设备及智能控制与监测领域射频通信解决方案的投资与开发。",

  "projects.construction.title": "TOP TEAM建筑",

  "projects.construction.desc": "Top Team Construction 是一家专注于建筑工程、基础设施建设及交钥匙工程项目的战略投资组合企业。",

  "projects.viewDetails": "查看详情",

  "projects.investmentFocus": "投资重点",

  "projects.investmentFocusDesc": "我们的投资组合企业覆盖多个战略行业，并通过资本支持、战略指导及运营管理经验，持续推动企业成长与价值提升。",

  "projects.viewAll": "查看全部项目",

  // Tags

  "tag.energy": "能源",

  "tag.batterySystems": "电池系统",

  "tag.industrial": "工业",

  "tag.electronics": "电子",

  "tag.iot": "物联网",

  "tag.smartSystems": "智能系统",

  "tag.construction": "建筑",

  "tag.infrastructure": "基础设施",

  "tag.development": "开发",

  // Values

  "values.label": "我们的价值观",

  "values.title1": "核心",

  "values.title2": "价值观",

  "values.description": "我们的核心价值观指导着每一项投资决策，并塑造着我们与合作伙伴的长期合作关系。",

  "values.integrity": "诚信",

  "values.integrityDesc": "我们始终秉持最高标准的诚信、责任与透明原则，建立并维护与合作伙伴、投资者及投资组合企业之间的长期信任。",

  "values.longTerm": "长期视野",

  "values.longTermDesc": "我们坚持以长期视野制定投资决策，发掘具备可持续增长潜力并顺应未来市场发展趋势的投资机会。",

  "values.excellence": "追求卓越",

  "values.excellenceDesc": "我们在投资、运营及公司治理的各个方面追求卓越，助力投资组合企业实现持续增长与长期成功。",

  "values.innovation": "创新",

  "values.innovationDesc": "我们积极支持创新理念与前沿技术，帮助投资组合企业不断创新、持续发展，并在快速变化的市场环境中保持竞争优势。",

  "values.collaboration": "合作共赢",

  "values.collaborationDesc": "我们重视与创始人、管理团队及各利益相关方建立长期稳固的合作关系，通过协作、专业指导与资源支持共同创造价值。",

  "values.quote": "我们的核心价值观不仅是企业发展的基石，更是我们与合作伙伴、投资者及投资组合企业建立长期信任与共同成长的基础。",

  // CTA

  "cta.label": "联系我们",

  "cta.title1": "让我们共同",

  "cta.title2": "创造未来",

  "cta.description": "无论您是寻求投资、合作机会,还是战略指导,我们都将竭诚为您提供帮助,助您实现目标。",

  "cta.contactUs": "联系我们",

  "cta.callNow": "立即致电",

  "cta.phone": "电话",

  "cta.email": "邮箱",

  "cta.website": "网站",

  "cta.location": "地址",

  // Footer

  "footer.description": "致力于打造稳健、多元化的国际投资集团，在能源、科技及工业领域持续创造长期价值。",

  "footer.quickLinks": "快速链接",

  "footer.portfolio": "投资组合",

  "footer.contact": "联系我们",

  "footer.aboutUs": "关于我们",

  "footer.batteryEnergy": "电池与储能",

  "footer.iotSmart": "物联网与智能系统",

  "footer.infrastructure": "基础设施开发",

  "footer.copyright": "© 2026 ALEBEL投资公司。保留所有权利。",

  "footer.privacy": "隐私政策",

  "footer.terms": "服务条款",

  // Language

  "language": "语言",

  "language.en": "English",

  "language.ar": "العربية",

  "language.zh": "中文",

  // About Page

  "aboutPage.breadcrumb.home": "首页",

  "aboutPage.breadcrumb.about": "关于我们",

  "aboutPage.hero.label": "关于",

  "aboutPage.hero.title1": "关于",

  "aboutPage.hero.title2": "ALEBEL",

  "aboutPage.hero.description": "ALEBEL是一家私人控股投资公司，专注于投资、收购及管理多个战略领域的多元化投资组合。",

  "aboutPage.story.title1": "我们的",

  "aboutPage.story.title2": "故事",

  "aboutPage.story.p1": "ALEBEL投资是一家战略性控股投资公司，专注于在区域及国际市场投资、收购、培育并支持具有高成长潜力的企业。",

"aboutPage.story.p2": "公司总部位于阿拉伯联合酋长国,为其投资组合公司提供资本支持、治理监督、战略规划和运营指导。",

"aboutPage.story.p3": "秉持长期投资理念，并以创新为驱动，ALEBEL致力于通过审慎投资、积极管理及战略合作，为股东、合作伙伴和社会创造可持续的长期价值。",

  // "aboutPage.story.p4": "公司不直接参与旗下企业的日常运营，而是通过资本支持、战略规划、公司治理及业务发展赋能投资组合企业。",

  // "aboutPage.story.p5": ALEBEL投资专注于能源、科技、制造业、电子及工业解决方案等战略领域，重点投资具有创新能力和可持续增长潜力的企业。",

  "aboutPage.established": "成立时间",

  "aboutPage.process.label": "我们的流程",

  "aboutPage.process.title1": "我们的",

  "aboutPage.process.title2": "运作方式",

  "aboutPage.process.step1.title": "评估",

"aboutPage.process.step1.desc": "我们持续发掘并评估具备可持续增长潜力、成熟商业模式、卓越运营能力及优秀管理团队的优质投资机会。",

"aboutPage.process.step2.title": "尽职调查",

"aboutPage.process.step2.desc": "我们进行全面的财务、运营、技术和法律评估,以确保符合我们的投资战略和长期目标。",

"aboutPage.process.step3.title": "积极管理",

"aboutPage.process.step3.desc": "我们与管理团队紧密合作，提供战略指导、公司治理及运营支持，推动企业实现可持续增长。",

"aboutPage.process.step4.title": "价值创造",

"aboutPage.process.step4.desc": "我们通过资本支持、战略规划、运营优化以及共享集团资源与商业网络，持续提升投资组合企业的长期价值。",

  "aboutPage.values.label": "我们的价值观",

  "aboutPage.values.title1": "核心",

  "aboutPage.values.title2": "价值观",

  "aboutPage.values.integrity": "诚信",

  "aboutPage.values.integrityDesc": "我们始终秉持最高标准的诚信、透明、责任与商业道德，建立并维护与合作伙伴及投资者之间的长期信任。",

  "aboutPage.values.longTerm": "长期视野",

  "aboutPage.values.longTermDesc": "我们坚持长期投资理念，以审慎决策和持续价值创造为导向，发掘具有长期发展潜力的投资机会。",

  "aboutPage.values.excellence": "追求卓越",

  "aboutPage.values.excellenceDesc": "我们在投资、运营及公司治理等各个方面追求卓越，不断提升企业价值与长期竞争力。",

  "aboutPage.values.innovation": "创新",

  "aboutPage.values.innovationDesc": "我们支持有助于推动未来经济增长与产业转型的创新驱动型企业与新兴技术。",

  "aboutPage.values.collaboration": "协作",

  "aboutPage.values.collaborationDesc": "我们相信通过与创始人、利益相关方及管理团队建立牢固的合作关系,实现共同成功。",

  // Services Page

  "servicesPage.breadcrumb.home": "首页",

  "servicesPage.breadcrumb.services": "服务",

  "servicesPage.hero.label": "我们提供的服务",

  "servicesPage.hero.title1": "我们的",

  "servicesPage.hero.title2": "服务",

  "servicesPage.hero.description": "全面的投资、战略咨询和业务支持服务,旨在加速企业和创业者的可持续增长。",

  "servicesPage.corporate.label": "面向企业",

  "servicesPage.corporate.title1": "企业",

  "servicesPage.corporate.title2": "服务",

  "servicesPage.corporate.description": "我们通过战略指导、治理框架、运营支持和长期业务发展计划,为投资组合公司及合作公司提供支持。",

  "servicesPage.corporate.item1.title": "财务支持",

  "servicesPage.corporate.item1.desc": "为战略增长计划提供资本支持及结构化融资解决方案。",

  "servicesPage.corporate.item2.title": "战略规划",

  "servicesPage.corporate.item2.desc": "长期业务规划与市场定位策略。",

  "servicesPage.corporate.item3.title": "公司治理",

  "servicesPage.corporate.item3.desc": "提供董事会治理、公司治理体系建设及组织架构优化支持。",

  "servicesPage.corporate.item4.title": "业务发展",

  "servicesPage.corporate.item4.desc": "支持市场拓展、战略合作及业务持续增长。",

  "servicesPage.corporate.item5.title": "资源网络",

  "servicesPage.corporate.item5.desc": "共享集团商业资源、投资者资源及行业合作网络。",

  "servicesPage.individual.label": "个人服务",

  "servicesPage.individual.title1": "创业者",

  "servicesPage.individual.title2": "支持",

  "servicesPage.individual.description": "我们通过投资、创业辅导及战略支持，帮助创业者和创新型创始人将创新理念转化为具有可持续增长潜力的企业。",

  "servicesPage.individual.item1.title": "创业孵化",

  "servicesPage.individual.item1.desc": "帮助创业者将创新理念转化为具备市场竞争力的企业。",

  "servicesPage.individual.item2.title": "初创企业投资",

  "servicesPage.individual.item2.desc": "投资具有强大市场潜力的早期及成长期项目。",

  "servicesPage.individual.item3.title": "法律架构",

  "servicesPage.individual.item3.desc": "投资具有市场潜力的早期及成长阶段创新企业。",

  "servicesPage.individual.item4.title": "创业指导",

  "servicesPage.individual.item4.desc": "提供战略咨询、运营辅导及企业成长支持。",

  "servicesPage.individual.item5.title": "技术指导",

  "servicesPage.individual.item5.desc": "支持产品开发、技术战略与创新落地。",

  "servicesPage.cta.title1": "准备好",

  "servicesPage.cta.title2": "与我们",

  "servicesPage.cta.title3": "携手共创未来了吗?",

  "servicesPage.cta.description": "无论您是寻求投资的企业,还是富有远见的创业者,我们都将竭诚为您提供帮助。",

  "servicesPage.cta.button": "联系我们",

  // Portfolio Page

"portfolioPage.breadcrumb.home": "首页",

"portfolioPage.breadcrumb.portfolio": "投资组合",

"portfolioPage.hero.label": "我们的投资",

"portfolioPage.hero.title1": "投资组合",

"portfolioPage.hero.title2": "企业",

"portfolioPage.hero.description": "多元化战略投资组合，聚焦可持续增长、产业创新及长期价值创造。",

"portfolioPage.energy.title": "ALEBEL能源解决方案",

"portfolioPage.energy.desc": "为电动工具、电动出行及工业应用开发并投资电池组、电池管理系统(BMS)和储能解决方案。",

"portfolioPage.energy.fullDesc": "ALEBEL能源解决方案专注于先进电池技术、储能系统及可持续能源基础设施，助力全球能源转型与绿色发展。",

"portfolioPage.electronics.title": "ALEBEL电子",

"portfolioPage.electronics.desc": "专注于电子产品研发、嵌入式系统、物联网设备及智能控制与监测领域射频通信解决方案的投资与开发。",

"portfolioPage.electronics.fullDesc": "ALEBEL电子专注于先进电子系统、物联网技术及智能通信解决方案的研发与投资，推动自动化、数字化及智能化发展。",

"portfolioPage.construction.title": "TOP TEAM建筑",

"portfolioPage.construction.desc": "Top Team Construction是一家专注于建筑工程、基础设施建设及交钥匙工程项目的战略投资组合企业。",

"portfolioPage.construction.fullDesc": "TOP TEAM建筑专注于基础设施、商业建筑及交钥匙开发项目,坚定致力于质量、安全与卓越运营。",

"portfolioPage.keyFocus": "重点领域:",

"portfolioPage.sectors.label": "投资重点",

"portfolioPage.sectors.title1": "战略",

"portfolioPage.sectors.title2": "领域",

"portfolioPage.sectors.energy": "能源",

"portfolioPage.sectors.energyDesc": "先进能源基础设施与可持续电力解决方案。",

"portfolioPage.sectors.technology": "科技",

"portfolioPage.sectors.technologyDesc": "创新驱动的数字化系统与智能科技。",

"portfolioPage.sectors.manufacturing": "制造业",

"portfolioPage.sectors.manufacturingDesc": "先进制造及现代工业生产能力。",

"portfolioPage.sectors.electronics": "电子",

"portfolioPage.sectors.electronicsDesc": "智能电子系统与通信技术。",

"portfolioPage.sectors.industrial": "工业",

"portfolioPage.sectors.industrialDesc": "工业基础设施与自动化解决方案。",

"portfolioPage.sectors.agricultural": "农业",

"portfolioPage.sectors.agriculturalDesc": "投资农业企业及可持续农业解决方案。",

"portfolioPage.sectors.tourism": "旅游业",

"portfolioPage.sectors.tourismDesc": "投资旅游项目及酒店管理。",

"portfolioPage.sectors.healthcare": "医疗健康",

"portfolioPage.sectors.healthcareDesc": "投资医疗健康服务、医疗机构及生命科学产业。",

"portfolioPage.sectors.commercial": "商业",

"portfolioPage.sectors.commercialDesc": "投资商业企业、商业运营及现代服务业。",

"portfolioPage.sectors.oilgas": "石油与天然气",

"portfolioPage.sectors.oilgasDesc": "投资石油、天然气及相关能源基础设施项目。",

"portfolioPage.sectors.educational": "教育",

"portfolioPage.sectors.educationalDesc": "投资教育机构、教育科技及人才培养项目。",

"portfolioPage.cta.title1": "期待",

"portfolioPage.cta.title2": "与您合作",

"portfolioPage.cta.description": "我们持续寻找具有创新精神和长期发展潜力的企业及创业者，共同创造长期价值。",

"portfolioPage.cta.button": "联系我们",

"portfolioPage.tags.energy": "储能",

"portfolioPage.tags.batterySystems": "电池技术",

"portfolioPage.tags.industrial": "工业能源解决方案",

"portfolioPage.tags.electricMobility": "电动出行",

"portfolioPage.tags.electronics": "电子",

"portfolioPage.tags.iot": "物联网",

"portfolioPage.tags.smartSystems": "智能系统",

"portfolioPage.tags.rfCommunication": "射频通信",

"portfolioPage.tags.construction": "建筑",

"portfolioPage.tags.infrastructure": "基础设施",

"portfolioPage.tags.development": "开发",

"portfolioPage.tags.turnkeyProjects": "交钥匙项目",

"portfolioPage.rd.title": "ALEBEL研发",

"portfolioPage.rd.desc": "研究与开发",

"portfolioPage.rd.fullDesc": "ALEBEL研发通过在能源、机器人、自动化和工业系统领域的先进研究与技术开发推动创新。",

"portfolioPage.robotics.title": "ALEBEL机器人",

"portfolioPage.robotics.desc": "机器人与自动化",

"portfolioPage.robotics.fullDesc": "ALEBEL机器人开发智能机器人系统及自动化技术,致力于提升工业生产力和智能制造能力。",

"portfolioPage.device.title": "ALEBEL设备",

"portfolioPage.device.desc": "智能设备与电子产品",

"portfolioPage.device.fullDesc": "ALEBEL设备为工业、商业及消费应用设计并制造先进的电子硬件和智能控制系统。",

"portfolioPage.tags.research": "研究",

"portfolioPage.tags.innovation": "创新",

"portfolioPage.tags.robotics": "机器人技术",

"portfolioPage.tags.automation": "自动化",

"portfolioPage.tags.ai": "人工智能",

"portfolioPage.tags.industrial.solutions": "工业解决方案",

"portfolioPage.tags.devices": "智能设备",

"portfolioPage.tags.embedded.systems": "嵌入式系统",

"portfolioPage.tech.title": "ALEBEL科技",

"portfolioPage.tech.desc": "提供推动企业数字化转型的综合技术解决方案。",

"portfolioPage.tech.fullDesc": "ALEBEL科技专注于数字化平台、企业软件及技术基础设施的研发与建设，助力阿联酋及区域市场企业加速数字化转型。",

"portfolioPage.tags.digital": "数字化",

"portfolioPage.tags.software": "软件",

"portfolioPage.tags.technology.development": "技术开发",

  // Contact Page

  "contactPage.breadcrumb.home": "首页",

  "contactPage.breadcrumb.contact": "联系我们",

  "contactPage.hero.label": "联系我们",

  "contactPage.hero.title1": "联系",

  "contactPage.hero.title2": "我们",

  "contactPage.hero.description": "准备好探讨投资机会或建立合作了吗？我们期待您的来信。",

  "contactPage.form.title": "给我们留言",

  "contactPage.form.success": "感谢您的留言！我们已成功收到您的信息，并将尽快与您联系。",

  "contactPage.form.name": "姓名",

  "contactPage.form.namePlaceholder": "您的姓名",

  "contactPage.form.email": "电子邮箱",

  "contactPage.form.emailPlaceholder": "your@email.com",

  "contactPage.form.company": "公司",

  "contactPage.form.companyPlaceholder": "您的公司",

  "contactPage.form.subject": "主题",

  "contactPage.form.subjectPlaceholder": "请选择主题",

  "contactPage.form.subjectInvestment": "投资咨询",

  "contactPage.form.subjectPartnership": "合作机会",

  "contactPage.form.subjectStartup": "创业支持",

  "contactPage.form.subjectGeneral": "一般咨询",

  "contactPage.form.message": "留言内容",

  "contactPage.form.messagePlaceholder": "请告诉我们您的咨询内容...",

  "contactPage.form.submit": "发送留言",

  "contactPage.form.sending": "发送中...",

  "contactPage.info.title": "联系信息",

  "contactPage.info.description": "无论您正在寻找投资机会、战略合作，还是专业咨询，我们都期待与您沟通，并为您的发展提供支持。",

  "contactPage.info.phone": "电话",

  "contactPage.info.email": "邮箱",

  "contactPage.info.website": "网站",

  "contactPage.info.location": "地址",

  "contactPage.info.locationValue": "阿拉伯联合酋长国迪拜",

  "contactPage.info.locationDesc": "阿联酋迪拜萨拉赫丁,Nasco大厦5楼501室",

  //"contactPage.info.locationDesc": "服务于区域及国际市场",

  "investPage.hero.label": "投资机会",

  "investPage.hero.title1": "开启",

  "investPage.hero.title2": "投资",

  "investPage.hero.description": "携手 ALEBEL，投资引领未来发展的战略产业。",  "investPage.form.title": "投资咨询",

  "investPage.form.name": "姓名",

  "investPage.form.namePlaceholder": "请输入您的姓名",

  "investPage.form.email": "电子邮箱",

  "investPage.form.emailPlaceholder": "your@email.com",

  "investPage.form.company": "公司名称",

  "investPage.form.companyPlaceholder": "请输入您的公司名称",

  "investPage.form.message": "留言内容",

  "investPage.form.messagePlaceholder": "请填写您的投资意向或咨询内容，我们将尽快与您联系",

  "investPage.form.submit": "发送咨询",

  "investPage.form.sending": "发送中...",

  "investPage.form.success": "感谢您的咨询！我们已成功收到您的信息，并将尽快与您联系。",

  "investPage.form.close": "关闭",

  "investPage.investments.agricultural": "农业投资与管理",

  "investPage.investments.tourist": "旅游业投资与管理",

  "investPage.investments.healthcare": "医疗健康投资与发展",

  "investPage.investments.commercial": "商业投资与运营",

  "investPage.investments.technological": "科技投资与管理",

  "investPage.investments.energy": "能源投资与管理",

  "investPage.investments.oil": "石油与天然气投资",

  "investPage.investments.industrial": "工业投资与管理",

  "investPage.investments.educational": "教育投资与发展",

  "sector.agricultural": "农业",

  "sector.tourism": "旅游业",

  "sector.healthcare": "医疗保健",

  "sector.commercial": "商业",

  "sector.oilgas": "石油与天然气",

  "sector.educational": "教育",

  "aboutPage.highlights.uaeBased": "立足阿联酋的投资集团",

"aboutPage.highlights.uaeBasedDesc": "总部位于阿联酋迪拜,专注于区域及国际投资机会。",

"aboutPage.highlights.multiSector": "多元化投资组合",

"aboutPage.highlights.multiSectorDesc": "投资覆盖能源、科技、电子、基础设施及工业等多个战略领域。",

"aboutPage.highlights.innovation": "聚焦创新",

"aboutPage.highlights.innovationDesc": "重点投资具有创新能力和可持续增长潜力的企业，共同塑造产业与科技的未来。",

"aboutPage.highlights.longTerm": "长期战略增长",

"aboutPage.highlights.longTermDesc": "秉持审慎的投资理念，专注于创造可持续的长期价值。",

"aboutPage.highlights.regional": "区域扩张战略",

"aboutPage.highlights.regionalDesc": "积极拓展海湾合作委员会（GCC）及其他区域市场的战略投资布局。",

"aboutPage.whyPartner.vision": "长期投资愿景",

"aboutPage.whyPartner.visionDesc": "我们坚持长期投资理念，陪伴企业成长，并支持其在各个发展阶段实现持续增长。",

"aboutPage.whyPartner.support": "战略运营支持",

"aboutPage.whyPartner.supportDesc": "我们为投资组合企业提供切实有效的战略指导、公司治理及运营支持，助力企业实现长期发展。",

"aboutPage.whyPartner.expertise": "行业专长",

"aboutPage.whyPartner.expertiseDesc": "在能源、科技、基础设施及工业等领域拥有丰富的行业经验，并深耕阿联酋及区域市场。",

"aboutPage.whyPartner.innovation": "创新驱动",

"aboutPage.whyPartner.innovationDesc": "我们积极发掘并支持具有创新能力和可持续增长潜力的企业。",

"aboutPage.whyPartner.market": "区域市场优势",

"aboutPage.whyPartner.marketDesc": "依托广泛的区域合作网络和市场资源，加速企业成长并拓展市场机遇。",

"projects.store.title": "ALEBEL商城",
"projects.store.desc": "一家高端电商平台,精选独家产品与奢华系列,将精致零售体验与前沿数字商务完美融合。",
"projects.tech.title": "ALEBEL科技",
"projects.tech.desc": "开发综合技术解决方案与创新数字服务,支持数字化转型,提升各行业的运营效率。",
"projects.healthcare.title": "ALEBEL医疗健康",
"projects.healthcare.desc": "投资医疗健康与制药企业,改善患者诊疗效果,推动医学创新,并提升区域医疗服务的可及性。",
"projects.racing.title": "ALEBEL赛车",
"projects.racing.desc": "通过战略投资赛车队、性能工程及速度文化,致力于在赛车运动领域追求卓越。",
"projects.device.title": "ALEBEL设备",
"projects.device.desc": "设计并制造创新电子设备及智能控制系统,应用于工业、商业及消费领域。",
"projects.rnd.title": "ALEBEL研发",
"projects.rnd.desc": "引领新兴技术的研究与开发,推动能源、电子及工业领域的创新,业务遍及阿联酋及海外市场。",
"projects.websiteLabel": "网站",
"tag.luxury": "奢华",
"tag.ecommerce": "电子商务",
"tag.retail": "零售",
"tag.technology": "科技",
"tag.digital": "数字化",
"tag.software": "软件",
"tag.healthcare": "医疗健康",
"tag.pharmaceuticals": "制药",
"tag.wellness": "健康",
"tag.motorsport": "赛车运动",
"tag.performance": "性能",
"tag.racing": "竞速",
"tag.devices": "设备",
"tag.smartTech": "智能科技",
"tag.research": "研究",
"tag.innovation": "创新",
"tag.technologyDev": "技术",

"portfolioPage.store.title": "ALEBEL商城",
"portfolioPage.store.desc": "奢华电子商务",
"portfolioPage.store.fullDesc": "一家高端电商平台,精选独家产品与奢华系列,将精致零售体验与前沿数字商务完美融合。",
"portfolioPage.healthcare.title": "ALEBEL医疗健康",
"portfolioPage.healthcare.desc": "医疗健康与制药",
"portfolioPage.healthcare.fullDesc": "投资医疗健康与制药企业,改善患者诊疗效果,推动医学创新,并提升区域医疗服务的可及性。",
"portfolioPage.racing.title": "ALEBEL赛车",
"portfolioPage.racing.desc": "赛车运动与性能",
"portfolioPage.racing.fullDesc": "通过战略投资赛车队、性能工程及速度文化,致力于在赛车运动领域追求卓越。",
"portfolioPage.visitWebsite": "访问网站",
"portfolioPage.metrics.companies": "投资组合公司",
"portfolioPage.metrics.sectors": "投资领域",
"portfolioPage.metrics.headquartered": "总部",
"portfolioPage.metrics.uaeValue": "阿联酋",
"portfolioPage.metrics.companyProfile": "公司简介",
"portfolioPage.metrics.company": "公司",
"portfolioPage.metrics.profile": "简介"

};

export default common;


